function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.1693 13.5417H54.8123C57.8115 13.5417 60.2653 15.9792 60.2653 18.9583V51.4583C60.2653 54.4375 57.8115 56.875 54.8123 56.875H11.1881C8.18897 56.875 5.73511 54.4375 5.73511 51.4583V18.9583C5.73511 15.9792 8.18897 13.5417 11.1881 13.5417H19.8312L24.8207 8.125H41.1797L46.1693 13.5417ZM11.1881 51.4583H54.8123V18.9583H43.7699L38.7804 13.5417H27.22L22.2305 18.9583H11.1881V51.4583ZM33.0002 21.6667C25.475 21.6667 19.3677 27.7333 19.3677 35.2083C19.3677 42.6833 25.475 48.75 33.0002 48.75C40.5254 48.75 46.6328 42.6833 46.6328 35.2083C46.6328 27.7333 40.5254 21.6667 33.0002 21.6667ZM24.8207 35.2083C24.8207 39.6771 28.5015 43.3333 33.0002 43.3333C37.499 43.3333 41.1797 39.6771 41.1797 35.2083C41.1797 30.7396 37.499 27.0833 33.0002 27.0833C28.5015 27.0833 24.8207 30.7396 24.8207 35.2083Z",
  fill: "url(#paint0_linear)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 33.0002,
  y1: 8.125,
  x2: 33.0002,
  y2: 56.875,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#0099BB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#007A6A"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/PhotoIcon.9ff03358.svg";
export { SvgComponent as ReactComponent };